import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_PENDING,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  LOGOUT_PENDING,
  SET_AUTH_CHECKED,
  SET_USER,
  SET_LOGIN_ERROR
} from "./actions";
import { TLoginActions } from "./actions";

type TLoginState = {
  success: boolean;
  error: boolean;
  pending: boolean;
  user: null | any;
  isAuthChecked: boolean,
  loginError: null | any
};

const initialState = {
  success: false,
  error: false,
  pending: false,
  user: null,
  isAuthChecked: false,
  loginError: null,
};

export const reducer = (state = initialState, action: TLoginActions): TLoginState => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        success: true,
        error: false,
        pending: false,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        success: false,
        error: true,
        pending: false,
      };
    case LOGIN_PENDING:
      return {
        ...state,
        success: false,
        error: false,
        pending: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        success: false,
        error: false,
        pending: false,
      };
    case LOGOUT_ERROR:
      return {
        ...state,
        success: false,
        error: true,
        pending: false,
      };
    case LOGOUT_PENDING:
      return {
        ...state,
        success: false,
        error: false,
        pending: true,
      };
    case SET_AUTH_CHECKED:
      return {
        ...state,
        isAuthChecked: action.payload
      }
    case SET_USER:
      return {
        ...state,
        user: action.payload
      }
    case SET_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.payload
      }
    default:
      return state;
  }
};
